"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("./request");
const response_1 = require("./response");
exports.default = {
    request: request_1.default,
    response: response_1.default
};
